import React, { Component, PropTypes } from 'react';
import { CourseStore, PageStore, ThemeStore, ClipboardStore } from 'stores';
import { history } from 'helpers';
import { mixin, RefluxMixin } from 'Util';
import update from 'react/lib/update';
import PageService from 'services/Page';
import {
  Toolbar,
  ToolbarGroup,
  TextField,
  FlatButton,
  RaisedButton,
  Card,
  CardText,
  Dialog,
  Styles
} from 'material-ui';
import ScrollableContainer from 'components/ScrollableContainer';
import * as Icons from 'components/Material/SvgIcons';
import { Note } from 'components/Icons';
import {
  CourseActions,
  AuthActions,
  AppActions,
  PageLayoutActions,
  ClipboardActions
} from 'actions';
import * as Colors from 'components/Material/Styles/Colors';
import Cover from 'components/Material/Cover';
import Loader from 'components/Material/Loader';
import { findDOMNode } from 'react-dom';
import Section from './Section';
import styles from './styles';
import CoursioLogo from 'components/CoursioLogo';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import { translate as _l } from 'oxygen-i18n';
import debounce from 'oxygen-debounce';

const { Spacing } = Styles;

addTranslations({
  'en-US': {
    'Retrieve diploma': 'Retrieve diploma',
    'Finish the course for a diploma': 'Finish the course for a diploma'
  },
  'sv-SE': {
    'Retrieve diploma': 'Ladda ner kursintyg',
    'Finish the course for a diploma': 'Slutför kursen för att få kursintyg'
  }
});

const css = oxygenCss({
  buttonWrapper: {
    padding: 8
  },
  search: {
    color: 'black',
    margin: 20
  },
  searchCard: {
    cursor: 'pointer',
    marginTop: 20,
    ':hover': {
      backgroundColor: `rgba(200, 200, 200, 0.4) !important`
    }
  },
  diplomaWarning: {
    padding: '16px 32px',
    lineHeight: '28px',
    fontSize: 20,
    borderRadius: 2,
    borderStyle: 'solid solid solid solid',
    borderWidth: 1,
    borderColor: '#faebcc',
    backgroundColor: '#fcf8e3',
    color: '#ba6d3b'
  }
});

export default class TableOfContents extends mixin(RefluxMixin, Component) {
  static displayName = 'TableOfContents';

  static propTypes = {
    links: PropTypes.bool,
    initialCollapsed: PropTypes.bool,
    ownerSlug: PropTypes.string,
    courseSlug: PropTypes.string,
    aside: PropTypes.bool,
    toc: PropTypes.array
  };

  static contextTypes = {
    muiTheme: PropTypes.object,
    getIntlMessage: PropTypes.func
  };

  static defaultProps = {
    links: true,
    aside: false,
    initialCollapsed: false,
    toc: []
  };

  constructor() {
    super(...arguments);
    this.state = {
      searchOpen: false,
      selectedSection: null,
      selectedPage: null,
      collapsed: this.props.initialCollapsed,
      sectionsCollapsed: false
    };
  }

  listenToStores() {
    this.listenToStore(PageStore);
    this.listenToStore(CourseStore);
    this.listenToStore(ClipboardStore, 'clipboard');
  }

  listenToActions() {
    this.listenToAction(CourseActions.addPageModuleComplete, () => {
      //this.refs.scroller.scrollToEnd();
    });
  }

  componentWillMount() {
    let { ownerSlug, courseSlug } = this.props;
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    CourseActions.findBySlug(ownerSlug, courseSlug);
  }

  search = debounce(() => {
    CourseActions.search(this.refs.courseSearch.getValue());
  }, 500);

  openSearch = () => {
    this.setState({ searchOpen: !this.state.searchOpen });
  };

  onSearchResultClick(pageId) {
    this.gotoPage(pageId);
  }

  gotoPage(pageId) {
    const { courseSlug, ownerSlug } = this.props;

    history.push(
      `/course/${ownerSlug}/${courseSlug}/${pageId}`
    );
  }

  moveSection(dragIndex, hoverIndex) {
    CourseActions.moveSection(this.props.course.id, dragIndex, hoverIndex);
  }

  movePageToSectionA(pageId, sectionId, position) {
    if (this._movePageToSection) {
      clearTimeout(this._movePageToSection);
    }
    this._movePageToSection = setTimeout(() => {
      PageService.moveToSection(pageId, sectionId, position);
    }, 1000);
  }

  movePageToSection(id, afterId, sectionId, newSectionId) {
    const sections = this.state.course.toc;

    const section = sections.filter(sect => sect.id === sectionId)[0];
    const newSection = sections.filter(sect => sect.id === newSectionId)[0];
    const sectionIndex = sections.indexOf(section);
    const newSectionIndex = sections.indexOf(newSection);

    const page = section.pages.filter(pageToFind => pageToFind.id === id)[0];
    const newPage = newSection.pages.filter(
      pageToFind => pageToFind.id === afterId
    )[0];
    const pageIndex = section.pages.indexOf(page);
    const newPageIndex = newSection.pages.indexOf(newPage);

    if (pageIndex < 0 || newPageIndex < 0) {
      return;
    }

    const updateObj = {
      course: {
        toc: {}
      }
    };
    updateObj.course.toc[sectionIndex] = {
      pages: {
        $splice: [[pageIndex, 1]]
      }
    };
    updateObj.course.toc[newSectionIndex] = {
      pages: {
        $splice: [[newPageIndex, 0, page]]
      }
    };
    this.setState(update(this.state, updateObj));
    this.movePageToSectionA(id, newSectionId, newPageIndex + 2);
  }

  updateTest(obj) {
    this.setState(update(this.state, obj));
  }

  collapse() {
    this.setState({ sectionsCollapsed: true });
  }

  expand() {
    this.setState({ sectionsCollapsed: false });
  }

  toggle() {
    this.setState({ collapsed: !this.state.collapsed });
  }

  addSection(courseId) {
    CourseActions.addSection(
      courseId,
      null,
      this.context.getIntlMessage('page.new'),
      this.context.getIntlMessage('section.new')
    );
  }

  onDeleteSection(sectionId) {
    this.setState({ selectedSection: sectionId });
    this.refs.confirmSectionDeleteDialog.show();
  }

  deleteSection(sectionId) {
    if (this.state.selectedSection) {
      CourseActions.deleteSection(this.state.selectedSection);
    }
    this.refs.confirmSectionDeleteDialog.dismiss();
    // this.refs.scrollbar.forceUpdate();
  }

  onDeletePage(pageId) {
    this.setState({ selectedPage: pageId });
    this.refs.confirmPageDeleteDialog.show();
    // this.refs.scrollbar.forceUpdate();
  }

  deletePage(pageId) {
    if (this.state.selectedPage) {
      CourseActions.deletePage(this.state.selectedPage);
    }
    this.refs.confirmPageDeleteDialog.dismiss();
    // this.refs.scrollbar.forceUpdate();
  }

  onUpdate() {
    // this.refs.scrollbar.update();
  }

  getStyles(theme) {
    const { rawTheme } = this.context.muiTheme;
    const themeColor = ThemeStore.getColor(theme);
    return {
      root: Object.assign(
        {},
        {
          backgroundColor: '#FAFAFA'
        }
      ),
      toolbar: Object.assign(
        {},
        {
          height: 60,
          backgroundColor: themeColor
        }
      ),
      page: Object.assign(
        {},
        {
          overflowX: 'hidden',
          overflowY: 'auto',
          color: rawTheme.palette.primary1TextColor
        }
      )
    };
  }

  toggle() {
    if (this.props.onToggle) {
      this.props.onToggle();
    }
  }

  scrollIntoView(domNode) {
    var containerDomNode = findDOMNode(this);
    let boundingRect = domNode.getBoundingClientRect();
    if (
      this.refs.scroller &&
      boundingRect.bottom >
        containerDomNode.scrollTop + containerDomNode.scrollHeight
    ) {
      this.refs.scroller.scrollTo(
        boundingRect.bottom - window.innerHeight / 2 + 100
      );
    }
  }

  toggleApplicationMenu() {
    AppActions.toggleAppBar();
  }

  closeToc() {
    CourseActions.closeToc();
  }

  toggleLayoutDesign() {
    PageLayoutActions.toggle();
  }

  builderMode() {
    AuthActions.builderMode();
  }

  showNotes = () => {
    CourseActions.toggleNotes();
  };

  readerMode() {
    AuthActions.readerMode();
  }

  pasteSection() {
    const section = ClipboardStore.paste().data;
    CourseActions.pasteSection(section);
  }

  retrieveDiploma = () => {
    const { course } = this.props;
    CourseActions.retrieveDiploma(course.id);
  };

  render() {
    if (!this.state.course) {
      return <Loader />;
    }
    let theme;
    if (
      this.state.course &&
      this.state.course.theme &&
      this.state.course.theme.color
    ) {
      theme = this.state.course.theme.color;
    } else {
      theme = 'creen';
    }
    const dynamicStyles = this.getStyles(theme);

    var sections = [],
      toc = this.state.course.toc || [],
      confirmSectionActions = [
        <FlatButton
          key="ok"
          label={this.context.getIntlMessage('OK')}
          secondary={true}
          className="half"
          onTouchTap={this.deleteSection.bind(this)}
        />
      ],
      confirmPageActions = [
        <FlatButton
          key="ok"
          label={this.context.getIntlMessage('OK')}
          secondary={true}
          className="half"
          onTouchTap={this.deletePage.bind(this)}
        />
      ];
    let pageCount = 0;
    const settings = !!this.state.course.settings
      ? { quiz: { enabled: false }, ...this.state.course.settings }
      : { quiz: { enabled: false } };
    sections = toc.map((section, index) => {
      pageCount += section.pages.length;

      if (section.type === 'quiz' &&
          (!settings.quiz.enabled || this.state.courseHasQuiziframe)) {
        return null;
      }

      return (
        <Section
          theme={theme}
          index={index}
          reader={this.props.reader}
          editor={this.props.editor}
          courseId={this.state.course.id}
          settings={settings}
          scrollIntoView={this.scrollIntoView.bind(this)}
          currentPage={this.props.currentPage}
          onUpdate={this.onUpdate.bind(this)}
          data={section}
          onDeletePage={this.onDeletePage.bind(this)}
          onDeleteSection={this.onDeleteSection.bind(this)}
          onMoveSection={this.moveSection.bind(this)}
          collapsed={false}
          key={section.id}
          mode={section.mode}
          ownerSlug={this.props.ownerSlug}
          courseSlug={this.props.courseSlug}
        />
      );
    });
    let addSectionButton;
    let pasteSectionButton;
    if (this.props.editor) {
      const { clipboard } = this.state;
      if (false && clipboard.object && clipboard.object.type === 'section') {
        pasteSectionButton = (
          <div style={styles.addSectionButtonContainer}>
            <RaisedButton
              backgroundColor={'transparent'}
              labelColor={Colors.Colors.fullWhite}
              fullWidth={true}
              style={styles.addSectionButton}
              onTouchTap={this.pasteSection.bind(this)}
            >
              <div style={styles.addPageLabel}>
                <Icons.ContentContentPaste
                  style={{ verticalAlign: 'middle' }}
                  color={Colors.Colors.fullWhite}
                />
                {this.context.getIntlMessage('section.paste')}
              </div>
            </RaisedButton>
          </div>
        );
      }

      addSectionButton = (
        <div style={styles.addSectionButtonContainer}>
          <RaisedButton
            backgroundColor={'transparent'}
            labelColor={Colors.Colors.fullWhite}
            fullWidth={true}
            style={styles.addSectionButton}
            onTouchTap={this.addSection.bind(this, this.state.course.id)}
          >
            <div style={styles.addPageLabel}>
              <Icons.ContentAdd
                style={{ verticalAlign: 'middle' }}
                color={Colors.Colors.fullWhite}
              />
              {this.context.getIntlMessage('section.new')}
            </div>
          </RaisedButton>
        </div>
      );
    }
    //        <div style={styles.logoContainer}>
    //          <img src={course.theme.logoUrl} style={styles.logo} />
    //        </div>

    let moduleLayoutButton;
    let switchButton;
    if (this.props.editor) {
      moduleLayoutButton = (
        <ToolbarIconButton
          tooltip={this.context.getIntlMessage('pageModule.layout')}
          tooltipPosition="bottom-center"
          svgIcon={<Icons.ActionViewModule />}
          onTouchTap={::this.toggleLayoutDesign}
        />
      );
      switchButton = (
        <ToolbarIconButton
          tooltip={this.context.getIntlMessage('settings.readerMode')}
          tooltipPosition="bottom-center"
          svgIcon={<Icons.ActionVisibility />}
          onTouchTap={::this.readerMode}
        />
      );
    } else if (this.props.auth.roleMap.editor && this.props.canEdit) {
      switchButton = (
        <ToolbarIconButton
          tooltip={this.context.getIntlMessage('settings.builderMode')}
          tooltipPosition="bottom-center"
          svgIcon={<Icons.ContentCreate />}
          onTouchTap={::this.builderMode}
        />
      );
    }

    const tocHeader = (
      <Toolbar style={dynamicStyles.toolbar}>
        <ToolbarGroup float={'left'} key={0}>
          <ToolbarIconButton
            svgIcon={<Icons.NavigationMenu />}
            onClick={this.toggleApplicationMenu}
          />
        </ToolbarGroup>
        <ToolbarGroup float={'right'} key={2}>
          {switchButton}
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('toc.search')}
            svgIcon={<Icons.ActionSearch />}
            onClick={this.openSearch}
          />
          {moduleLayoutButton}
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('toc.close')}
            tooltipPosition="bottom-center"
            svgIcon={<Note height={22} strokeWidth={2} />}
            onClick={this.showNotes}
          />
          <ToolbarIconButton
            tooltip={this.context.getIntlMessage('toc.close')}
            tooltipPosition="bottom-center"
            svgIcon={<Icons.NavigationChevronLeft />}
            onClick={this.closeToc}
          />
        </ToolbarGroup>
      </Toolbar>
    );

    const { course } = this.state;
    const hasDiploma = settings.diploma && settings.diploma.fileId;
    const { passPercentage } = settings.diploma || 80;
    const finished = (course.progress || 0) >= passPercentage / 100;
    return (
      <ScrollableContainer
        ref="scroller"
        style={dynamicStyles.root}
        header={tocHeader}
      >
        <Cover
          image={
            this.state.course.coverImage && this.state.course.coverImage.url
          }
        >
          <div style={styles.coverCaption}>
            <div style={styles.coverCourseName}>{course.name}</div>
            <div style={styles.coverCourseBy}>
              {this.context.getIntlMessage('by')} {course.ownerName}
            </div>
          </div>
        </Cover>
        <div style={dynamicStyles.page}>
          {this.props.children}
          {!sections.length && addSectionButton}
          {!this.state.searchOpen ? (
            sections
          ) : (
            <div>
              <TextField
                style={{
                  margin: 20
                }}
                fullWidth
                ref="courseSearch"
                onChange={this.search}
                hintText={this.context.getIntlMessage('toc.search')}
              />
              <section className={css.search}>
                {this.state.search.map(c => {
                  return (
                    <Card
                      className={css.searchCard}
                      onClick={() => this.onSearchResultClick(c.pageId)}
                      >
                      <CardText>
                        <div dangerouslySetInnerHTML={{ __html: c.content }} />
                      </CardText>
                    </Card>
                  );
                })}
              </section>
            </div>
          )}
          {pasteSectionButton}
        </div>
        {hasDiploma && (
          <div className={css.buttonWrapper}>
            {finished && (
              <RaisedButton
                onTouchTap={this.retrieveDiploma}
                backgroundColor={ThemeStore.getColor(theme)}
                labelColor="#FFF"
                fullWidth
                label={_l`Retrieve diploma`}
              />
            )}
            {!finished && (
              <div className={css.diplomaWarning}>
                {_l`Finish the course for a diploma`}
              </div>
            )}
          </div>
        )}
        <Dialog
          ref="confirmSectionDeleteDialog"
          title={this.context.getIntlMessage('section.remove')}
          actions={confirmSectionActions}
          dismissOnClickAway={true}
        >
          {this.context.getIntlMessage('section.confirmDelete')}
        </Dialog>
        <Dialog
          ref="confirmPageDeleteDialog"
          title={this.context.getIntlMessage('page.remove')}
          actions={confirmPageActions}
          dismissOnClickAway={true}
        >
          {this.context.getIntlMessage('page.confirmDelete')}
        </Dialog>
      </ScrollableContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Course/TableOfContents/TableOfContents.js